import React from 'react';
import {
  Action, ICON_MESSAGE_REPLY_TEXT_OUTLINE, Message, Text, useNotifications,
} from '@doveit/bricks';
import { useLocation } from 'react-router-dom';
import SimplePageLayout from '../../../layouts/simple-page-layout/SimplePageLayout';
import { useCanvaAuthContext } from '../../../contexts/canva-auth-context/CanvaAuthContext';

export const LOGIN_CANVA_ERROR_MESSAGE = "Errore durante l'accesso a Canva. Riprova o contatta l'assistenza.";

const LoginCanvaPage: React.FC = () => {
  const { state } = useLocation();
  const { login } = useCanvaAuthContext();
  const { addError } = useNotifications();
  const [isLoading, setIsLoading] = React.useState(false);

  const loginToCanva = React.useCallback(async () => {
    setIsLoading(true);
    try {
      await login(state?.from ?? '/marketing/canva/explore');
    } catch {
      addError(LOGIN_CANVA_ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  }, [state, login, addError]);

  return (
    <SimplePageLayout wrapperSize="S">
      <Message
        boxed
        message="Non hai fatto accesso a Canva"
        icon={ICON_MESSAGE_REPLY_TEXT_OUTLINE}
        description={(
          <Text.BodySmall>
            Per accedere ai template e ai design devi prima loggarti con il tuo account.
          </Text.BodySmall>
        )}
        actions={[(
          <Action
            label="Accedi a Canva"
            onClick={loginToCanva}
            emphasis="high"
            size="S"
            loading={isLoading}
          />
        )]}
      />
    </SimplePageLayout>
  );
};

export default LoginCanvaPage;
